const sockets = new Map();


window.openWebSocketConnection = function(url, timeoutMs, webSocketComponentRef, onMessageReceived, onClosed, onError) {
    return new Promise((resolve, reject) => {
        let settled = false;
        let ws;
        try {
            ws = new WebSocket(url);
        } catch (err) {
            reject(`Failed to open websocket connection: ${err?.toString()}`);
            return;
        }

        const id = crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2);

        const timer = setTimeout(() => {
            if (settled) return;
            settled = true;
            try { ws.close(); } catch {}
            reject(`WebSocket connection timed out after ${timeoutMs}ms`);
        }, timeoutMs);

        ws.onopen = () => {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            sockets.set(id, ws);

            ws.onmessage = (ev) => {
                try { webSocketComponentRef.invokeMethodAsync(onMessageReceived, ev.data); } catch {}
            };

            ws.onclose = (ev) => {
                try { webSocketComponentRef.invokeMethodAsync(onClosed, ev.code, ev.reason || ''); } catch {}
                sockets.delete(id);
            };

            ws.onerror = (_) => {
                try { webSocketComponentRef.invokeMethodAsync(onError); } catch {}
            };

            resolve(id);
        };

        ws.onerror = (_) => {
            if (settled) return;
            settled = true;
            clearTimeout(timer);
            reject('WebSocket encountered an error');
        };
    });
}

window.sendMessageOverWebSocketConnection = function(id, data) {
    const ws = sockets.get(id);
    if (!ws) throw 'WebSocket not found for id: ' + id + '';
    if (ws.readyState !== WebSocket.OPEN) throw 'WebSocket is not open';
    ws.send(data);
}

window.closeWebSocketConnection = function(id, code = 1000, reason = '') {
    const ws = sockets.get(id);
    if (!ws) return;
    try { ws.close(code, reason); } catch {}
    sockets.delete(id);
}